var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v(" 版權所有 2020 LiveABC互動英語教學集團 | Hebron Soft Limited All Rights Reserved ")])}
var staticRenderFns = []

export { render, staticRenderFns }